import { Data } from '@lottiefiles/dotlottie-react'
import { useEffect, useState } from 'react'

export const useStarAnim = () => {
  const [starAnim, setStarAnim] = useState<Data>()

  useEffect(() => {
    fetch('/lottie/starAnim.lottie')
      .then((res) => res.arrayBuffer())
      .then((data) => {
        setStarAnim(data)
      })
  }, [])

  return { starAnim }
}
